import Customer from "./Customer";
import Carrier from "./Carrier";
import OrderItem from "./OrderItem";
import OrderLocation from "./OrderLocation";
import OrderContact from "./OrderContact";
import OrderStatusLog from "./OrderStatusLog";
import BaseModel from "./BaseModel";
import OrderNote from "./OrderNote";
import Employee from "./Employee";
import Contact from "./Contact";
import Location from "./Location";
import PriceList from "./PriceList";
import EstimateItem from "./EstimateItem";
import EstimateStatusLog from "./EstimateStatusLog";

export default class Estimate extends BaseModel {

	static entity = 'estimates';
	static route = 'estimates';
	static plural = 'estimates';
	static singular = 'estimate';

	static fields () {
		return {
			id: this.attr(null),
			number: this.attr(null),
			employee_id: this.attr(null),
			employee: this.belongsTo(Employee, 'employee_id'),
			customer_id: this.attr(null),
			customer: this.belongsTo(Customer, 'customer_id'),
			contact_id: this.attr(null),
			contact: this.belongsTo(Contact, 'contact_id'),
			location_id: this.attr(null),
			location: this.belongsTo(Location, 'location_id'),
			shipping_id: this.attr(null),
			shipping: this.belongsTo(Location, 'shipping_id'),
			price_list_id: this.attr(null),
			price_list: this.belongsTo(PriceList, 'price_list_id'),
			pending_customer_id: this.attr(null),
			plan_number: this.attr(null),
			attention: this.attr(null),
			additional_emails: this.attr(null),
			tax_total: this.attr(null),
			sub_total: this.attr(null),
			total: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			deleted_at: this.attr(null),
			estimate_items: this.hasMany(EstimateItem, 'estimate_id', 'id'),
			estimate_status_logs: this.hasMany(EstimateStatusLog, 'estimate_id', 'id')
		}
	}

}
